<template>
    <a :href="url">
        <div class="box-imagem">
            <figure>
                <img :src="image.url" :width="image.width" :height="image.height">
            </figure>
            <div class="box-categoria">
                <span class="arrow-left" :style="'border-bottom-color:' + cor"></span>
                <div class="categoria" :style="'background-color:' + cor">
                    {{ categoria }}
                </div>
            </div>
        </div>
        <div class="box-texto" :style="'color:' + cor +'; border-bottom:2px solid '+ cor">
            <div class="data-card">
               {{ publicacao }}
            </div>
            <div class="titulo-card">
               {{ titulo.substring(0, 35) }} {{titulo.length > 35 ? '...' : ''}}
            </div>
            <div class="desc limita-texto">
                {{ chamada.substring(0, 70) }} {{chamada.length > 70 ? '...' : ''}}
            </div>
            <span class="leia-mais">Leia +</span>
        </div>
    </a>
</template>

<script>
    export default {
        props: {
            url: String,
            image: Object,
            cor: String,
            titulo: String,
            publicacao: String,
            categoria: String,
            chamada: String
        },
    };
</script>